export default __webpack_public_path__ + "static/media/ev-d2.90bfcc19.jpg";